module.exports = [
    { text:"Any Condition", value:"or" },
    { text:"All Conditions", value:"and" },
];